(ns manage.ad-variant-insights.tables.ad-variants
  (:require ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [clojure.string :as str]
            [common.resource.query.adset-activation :refer [adset-activations-query]]
            [common.widgets.data-grid :as dg]
            [manage.ad-variant-insights.tables.common :as table.common]
            [uix.core :as uix :refer [$ defui]]))

(def ad-variant-columns
  #js [#js {:field "ad-variant"
            :headerName "Ad Variant"
            :flex 6
            :minWidth 200
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (str/join " · " (cond-> [(:content-id row)]
                                             (seq (:dimensions row)) (conj (let [{:keys [width height]} (:dimensions row)]
                                                                             (str width "x" height))))))}
       #js {:field "impressions"
            :headerName "Impressions"
            :flex 1
            :align "right"
            :headerAlign "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (get-in row [:analytics :total :impressions]))
            :valueFormatter table.common/format-number}
       #js {:field "clicks"
            :headerName "Clicks"
            :flex 1
            :align "right"
            :headerAlign "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (get-in row [:analytics :total :clicks]))
            :valueFormatter table.common/format-number}
       #js {:field "ctr"
            :headerName "CTR"
            :flex 1
            :align "right"
            :headerAlign "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (let [clicks (get-in row [:analytics :total :clicks])
                                 impressions (get-in row [:analytics :total :impressions])]
                             (when (and (some? clicks) (pos-int? impressions))
                               (/ clicks impressions))))
            :valueFormatter table.common/format-ctr}])

(def field->sort-field
  {"impressions" "impressions>"
   "clicks" "clicks>"
   "ctr" "ctr>"})

(def field->resolver
  {"ad-variant" "error-timestamp"
   "impressions" "adset-id"
   "clicks" "facebook-adset-id"
   "ctr" "published-facebook-ad-id"
   "error-type" "error-type"
   "error-message" "error-message"})

(def query-filter-params
  {:field->sort-field field->sort-field
   :field->resolver field->resolver
   :default-sorting {:field "ctr>" :sort "desc"}})

(defn get-ad-variant-row-id [row]
  (:ad-variant-uuid row))

(defui ad-variant-rankings-table [{:keys [adset-id advertiser-id]}]
  (let [initial-pagination-model #js {:page 0 :pageSize 5}

        table-query-fn (uix/use-callback
                        (fn [table-models]
                          (adset-activations-query
                           {:adset-id adset-id
                            :advertiser-id advertiser-id}
                           query-filter-params
                           table-models))
                        [advertiser-id adset-id])

        server-table-props (dg/use-server-table-props
                            {:initial-pagination-model initial-pagination-model
                             :table-query-fn table-query-fn
                             :prevent-loading-on-refetch true})]
    ($ DataGridPremium
       (merge
        server-table-props
        {:columns ad-variant-columns
         :slots #js {:noRowsOverlay table.common/NoRowsOverlay}
         :getRowId get-ad-variant-row-id}))))

